var _style, _rect, _text, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 344.3 270",
    style: {
      enableBackground: "new 0 0 344.3 270"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{display:none;}\r\n\t.st2{font-family:'BellMT';}\r\n\t.st3{font-size:79px;}\r\n\t.st4{fill:#EBCA94;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.2,
    y: 33,
    className: "st0",
    width: 330,
    height: 198
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 41.1915 85.7715)",
    className: "st1 st2 st3"
  }, "\u2018\u2018")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84.7,265c-20.9,0-39.1-7.6-54.7-22.7c-15.6-15.1-23.4-34-23.4-56.7c0-43.1,23-84.3,69.1-123.5 c46-39.1,75.3-58.7,87.7-58.7c8.9,0,13.3,4,13.3,12c0,3.6-15.6,18.2-46.7,44c-33.8,28-50.7,52-50.7,72.1 c0,11.6,10.2,22.5,30.7,32.7c22.7,11.1,34,27.1,34,48c0,14.2-5.5,26.6-16.4,37C116.8,259.8,102.4,265,84.7,265z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M244.3,265c-20.9,0-39.1-7.6-54.7-22.7c-15.6-15.1-23.4-34-23.4-56.7c0-43.1,23-84.3,69.1-123.5 C281.3,23,310.6,3.4,323,3.4c8.9,0,13.3,4,13.3,12c0,3.6-15.6,18.2-46.7,44c-33.8,28-50.7,52-50.7,72.1c0,11.6,10.2,22.5,30.7,32.7 c22.7,11.1,34,27.1,34,48c0,14.2-5.5,26.6-16.4,37C276.4,259.8,262.1,265,244.3,265z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommas);
export default __webpack_public_path__ + "static/media/commas.7e9bc61b63dc6508e2e76039bc004a7c.svg";
export { ForwardRef as ReactComponent };